///jacques-andre-editeur\proshop-v2\frontend\src\screens\BookScreen.jsx
//import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import {
  useDispatch,
//  useSelector // resservira sûrement
 } from 'react-redux';
import {
  Container, Tabs, Tab
  //Row, Col, Image, ListGroup, Card, Button, Form,
} from 'react-bootstrap';
import {
  useGetBookDetailsQuery, useGetBooksByAuthorQuery, useGetBooksByTranslatorQuery } from '../slices/booksApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
//import Meta from '../components/Meta';
import { addToCart } from '../slices/cartSlice';
import { formatISBN } from '../utils/utils';
import { useState } from 'react';
import BookCard from '../components/BookCard';
import BooksCollectionCard from '../components/BooksCollectionCard';





const BookScreen = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();


  //const [qty, setQty] = useState(1);
  const qty = 1;
  
  const [showMessage, setShowMessage] = useState(false);

  const addToCartHandler = () => {
    dispatch(addToCart({ ...book, qty }));
    setShowMessage(true);
    setTimeout(() => {
      setShowMessage(false);
    }, 2000); // 2 secondes
  };

  const {
    data: book,
    isLoading,
  //    refetch, // resservira sûrement
    error,
  } = useGetBookDetailsQuery({ slug });

  
  const { data: booksByAuthor1 } = useGetBooksByAuthorQuery(book?.author1?._id, {
    skip: !book?.author1?._id,
  });
  const { data: booksByAuthor2 } = useGetBooksByAuthorQuery(book?.author2?._id, {
    skip: !book?.author2?._id,
  });
  const { data: booksByTranslator } = useGetBooksByTranslatorQuery(book?.translator?._id, {
    skip: !book?.translator?._id,
  });

  const booksByAuthor1Filtered = booksByAuthor1?.filter((b) => b._id !== book?._id).slice(0, 4);
  const booksByAuthor2Filtered = booksByAuthor2?.filter((b) => b._id !== book?._id).slice(0, 4);
  const booksByTranslatorFiltered = booksByTranslator?.filter((b) => b._id !== book?._id).slice(0, 4);

  // const { userInfo } = useSelector((state) => state.auth); // resservira sûrement, notamment pour que les admins puissent faire des modifs peut-être

  return (
    <Container>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}
        </Message>
      ) : (
      <div className="bookProfile">
        
        <div className="coverColumn">
          <div className="bookProfile-img-container no-margin-paragraphs">
            <img src={book?.cover} className="bookProfile-img" alt={`${book?.title}`} title={`${book?.title}`} />
            <button
                className='addToCartButton'
                type='button'
                disabled={book?.countInStock === 0}
                onClick={addToCartHandler}
              >
              Ajouter au panier
            </button>
          
            {showMessage && (
              <p className="confirmationMessage">Panier mis à jour</p>
            )}
            {book?.price && (<span className="bookPrice">Prix : {book?.price} €</span>)}      
            {book?.isbn && <p>ISBN : {formatISBN(book?.isbn)}</p>}
            {/* {book?.booksCollection?.name && (
              book?.booksCollection?.name?.trim().toLowerCase() === 'hors collection' ? (
                <p>{book?.booksCollection?.name}</p>
              ) : (
                <p>Collection : {book?.booksCollection?.name}</p>
              )

            )} */}
            {book?.booksCollection?.name?.trim().toLowerCase() !== 'hors collection' && (
              <p>Collection : {book.booksCollection.name}</p>
            )}

            {book?.nbPages > 0 && (<p>{book?.nbPages} pages</p>)}
            {book?.hauteur > 0 && (<p>Hauteur : {book?.hauteur} cm</p>)}
            {book?.largeur > 0 && (<p>Largeur : {book?.largeur} cm</p>)}
            {book?.poids > 0 && (<p>Poids : {book?.poids} g</p>)}
          </div>
          <div className="catchphrase">{book?.catchphrase}</div>
        </div>
        <div className="textColumn">
          <h1>{book?.title}</h1>
          <div className="subtitle">{book?.subtitle}</div>
          <div className="ligneAuteurs">
            <Link to={`/auteur/${book?.author1?.slug}`}>{book?.author1?.firstName && (book?.author1?.firstName)} {book?.author1?.lastName}</Link>
            {book?.author2 && (
              <>
                , <Link to={`/auteur/${book?.author2?.slug}`}>
                    {book?.author2?.firstName ? book?.author2?.firstName + ' ' : ''}
                    {book?.author2?.lastName || ''}
                </Link>
              </>
            )}

          </div> 
          <div className="ligneAutres">
            {book?.translator ? (
              <>
                Traduit {book?.language} par <Link to={`/auteur/${book?.translator?.slug}`}>
                  {book?.translator?.firstName && `${book?.translator?.firstName} `}
                  {book?.translator?.lastName}
                </Link>
                {book?.preface && `, préface de ${book?.preface}`}
                {book?.illustrations && `, illustrations de ${book?.illustrations}`}
              </>
            ) : book?.preface ? (
              <>
                Préface de {book?.preface}
                {book?.illustrations && `, illustrations de ${book?.illustrations}`}
              </>
            ) : book?.illustrations ? (
              <>Illustrations de {book?.illustrations}</>
            ) : null}
          </div>

            
          <Tabs defaultActiveKey="description" className="mt-3">
            {book?.description && (
              <Tab eventKey="description" title="Présentation" className='mobileTab'>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(book?.description) }} className="p-3" />
              </Tab>
            )}
            {book?.sommaire && (
              <Tab eventKey="sommaire" title="Sommaire" className='mobileTab'>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(book?.sommaire) }} className="p-3 no-margin-paragraphs" />
              </Tab>
            )}
            {book?.bonnepage && (
              <Tab eventKey="bonnepage" title="Bonne page" className='mobileTab'>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(book?.bonnepage) }} className="p-3" />
              </Tab>
            )}
          </Tabs>
        </div>
      </div>
        )}

        {(booksByAuthor1Filtered?.length > 0 || booksByAuthor2Filtered?.length > 0 || booksByTranslatorFiltered?.length > 0) && (
            <>
              {
              (booksByAuthor2Filtered?.length > 0 || (booksByTranslatorFiltered?.length > 0 && (book?.translator?._id !== book?.author1?._id) && (book?.translator?._id !== book?.author2?._id))) ? (
                <div className="h1-container">
                  <h1>Des mêmes auteurs</h1>
                </div>
              ) : (
                <div className="h1-container">
                  <h1>Du même auteur</h1>
                </div>
              )}
              {booksByAuthor1Filtered?.length > 0 && (
                <>
                  <h2><Link to={`/auteur/${book?.author1?.slug}`}>
                  {book?.author1?.firstName && `${book?.author1?.firstName} `}
                  {book?.author1?.lastName}</Link></h2>
                  <div className="book-author-row">
                    {booksByAuthor1Filtered.map((book) => (
                      <div className='book-card' key={book?._id}>
                        <BookCard book={book} showPanier={true} />
                      </div>
                    ))}
                  </div>
                  <Link to={`/auteur/${book?.author1?.slug}`}><p className='enSavoirPlus'>
                  En savoir plus sur {book?.author1?.firstName && `${book?.author1?.firstName} `}
                  {book?.author1?.lastName} et tous ses livres</p></Link>
                </>
              )}
              {booksByAuthor2Filtered?.length > 0 && (
                <>
                  <h2><Link to={`/auteur/${book?.author2?.slug}`}>
                  {book?.author2?.firstName && `${book?.author2?.firstName} `}
                  {book?.author2?.lastName}</Link></h2>
                  <div className="book-author-row">
                    {booksByAuthor2Filtered.map((book) => (
                      <div className='book-card' key={book?._id}>
                        <BookCard book={book} showPanier={true} />
                      </div>
                    ))}
                  </div>
                  <Link to={`/auteur/${book?.author2?.slug}`}><p className='enSavoirPlus'>
                  En savoir plus sur {book?.author2?.firstName && `${book?.author2?.firstName} `}
                  {book?.author2?.lastName} et tous ses livres</p></Link>
                </>
              )}
              
              {booksByTranslatorFiltered?.length > 0 && (
                <>
                  <h2>Traductions de <Link to={`/auteur/${book?.translator?.slug}`}>
                  {book?.translator?.firstName && `${book?.translator?.firstName} `}
                  {book?.translator?.lastName}</Link></h2>
                  <div className="book-author-row">
                    {booksByTranslatorFiltered.map((book) => (
                      <div className='book-card' key={book?._id}>
                        <BookCard book={book} showPanier={true} />
                      </div>
                    ))}
                  </div>
                  <Link to={`/auteur/${book?.translator?.slug}`}><p className='enSavoirPlus'>
                  En savoir plus sur {book?.translator?.firstName && `${book?.translator?.firstName} `}
                  {book?.translator?.lastName} et tous ses livres</p></Link>
                </>
              )}
              
              {(book?.booksCollection && book?.booksCollection.name !== "Hors collection" &&
                <>
                  <div className="h1-container">
                    <h1>Dans la même collection</h1>
                  </div>
                  <BooksCollectionCard booksCollection={book?.booksCollection} />
                </>
              )}
                
            </>
          )}
    </Container>
  );
};

export default BookScreen;
